import "./my-data.scss";
import { Row, Col, FormGroup, Label, Input } from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import MyAccountWrapper from "../../layout/my-account-wrapper/my-account-wrapper";
import { useContext } from "react";
import { AuthUserContext } from "../../contexts/authUserContext";
import { LoadingContext } from "../../contexts/loadingContext";
import axios from "axios";
import api from "./../../services/api";
import ReactInputMask from "react-input-mask";

import Swal from "sweetalert2";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 10000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  },
});

const validationSchema = Yup.object().shape({
  fullName: Yup.string().required("Nome completo é obrigatório"),
  email: Yup.string().email("E-mail inválido").required("E-mail é obrigatório"),
  cpf: Yup.string().required("CPF é obrigatório"),
  phone: Yup.string().required("Celular é obrigatório"),
  instagram: Yup.string().nullable(),
  zipCode: Yup.string().required("CEP é obrigatório"),
  address: Yup.string().required("Endereço é obrigatório"),
  neighborhood: Yup.string().required("Bairro é obrigatório"),
  number: Yup.string().required("Número é obrigatório"),
  complement: Yup.string().nullable(),
  city: Yup.string().required("Cidade é obrigatória"),
  state: Yup.string().required("Estado é obrigatório"),
});

const pageDescription = (
  <div className={"mb-4"}>
    Oi <strong>Fábio Onofre</strong>.
    <br />
    <br />
    Atualize sempre que quiser os dados da sua conta Adoleta.
  </div>
);

function MyData() {
  const { setIsLoadingGlobal } = useContext(LoadingContext);
  const { authUser, setAuthUser } = useContext(AuthUserContext);
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onBlur",
    defaultValues: {
      fullName: authUser.name,
      email: authUser.email,
      cpf: authUser.cpf,
      phone: authUser.phone,
      instagram: authUser.instagram,
      zipCode: authUser.address?.[0]?.postal_code || '',
      address: authUser.address?.[0]?.street || '',
      neighborhood: authUser.address?.[0]?.district || '',
      number: authUser.address?.[0]?.number || '',
      complement: authUser.address?.[0]?.complement || '',
      city: authUser.address?.[0]?.city || '',
      state: authUser.address?.[0]?.state || '',
    },
  });

  const onSubmit = async (data) => {
    const payload = {
      name: data.fullName,
      email: data.email,
      cpf: data.cpf.replace(/[^\d]/g, ''),
      phone: data.phone.replace(/[^\d]/g, ''),
      instagram: data.instagram,
      postal_code: data.zipCode.replace("-", ""),
      street: data.address,
      number: data.number.replace(/[^\d]/g, ''),
      complement: data.complement,
      district: data.neighborhood,
      city: data.city,
      state: data.state,
    };
    try {
      setIsLoadingGlobal(true);
      await api.put(`clients/${authUser.id}`, payload);
      const newAuthUser =
      {
        ...authUser,
        name: payload.name,
        email: payload.email,
        cpf: payload.cpf,
        telefone: payload.phone,
        instagram: payload.instagram,
        address: [{
          ...authUser.address,
          postal_code: payload.postal_code,
          street: payload.street,
          number: payload.number,
          complement: payload.complement,
          district: payload.district,
          city: payload.city,
        }]
      };
      setAuthUser({ ...authUser, ...newAuthUser });
      Toast.fire({
        icon: "success",
        title: `Sua conta foi atualizada com sucesso!`,
      });
    } catch (error) {
      Toast.fire({
        icon: "error",
        title: `Error ao atualizar a conta, por favor contacte um administrador!`,
      });
    } finally {
      setIsLoadingGlobal(false);
    }
  };

  const handleCepBlur = async (e) => {
    const cleanedCEP = e.target.value.replace("-", "");
    if (cleanedCEP.length === 8) {
      try {
        setIsLoadingGlobal(true);
        const response = await axios.get(
          `https://viacep.com.br/ws/${cleanedCEP}/json/`
        );
        if (response.erro) {
          alert("CEP não encontrado");
          return;
        }
        setValue("address", response.data.logradouro);
        setValue("neighborhood", response.data.bairro);
        setValue("state", response.data.estado);
        setValue("city", response.data.localidade);
      } catch (error) {
        console.error("Erro ao buscar o CEP: ", error);
      } finally {
        setIsLoadingGlobal(false);
      }
    }
  };

  return (
    <div className={"my-data"}>
      <MyAccountWrapper
        pageName={"Meus Dados"}
        pageDescription={pageDescription}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <div>
            <h4>Dados Pessoais</h4>
            <Row>
              <Col xl="8">
                <FormGroup className={"form-group"}>
                  <Label for="fullName" className="">
                    Nome completo
                  </Label>
                  <Controller
                    name="fullName"
                    control={control}
                    render={({ field }) => <Input {...field} type="text" />}
                  />
                  {errors.fullName && (
                    <span className="text-danger">
                      {errors.fullName.message}
                    </span>
                  )}
                </FormGroup>
              </Col>
              <Col xl="4">
                <FormGroup>
                  <Label for="email" className="">
                    Seu e-mail
                  </Label>
                  <Controller
                    name="email"
                    control={control}
                    render={({ field }) => <Input {...field} type="email" />}
                  />
                  {errors.email && (
                    <span className="text-danger">{errors.email.message}</span>
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xl="4">
                <FormGroup>
                  <Label for="cpf" className="">
                    CPF
                  </Label>
                  <Controller
                    name="cpf"
                    control={control}
                    render={({ field }) => <Input {...field} type="text" />}
                  />
                  {errors.cpf && (
                    <span className="text-danger">{errors.cpf.message}</span>
                  )}
                </FormGroup>
              </Col>
              <Col xl="4">
                <FormGroup>
                  <Label for="phone" className="label">
                    Celular <span>preferência por whatsapp</span>
                  </Label>
                  <Controller
                    name="phone"
                    control={control}
                    render={({ field }) => <Input {...field} type="text" />}
                  />
                  {errors.phone && (
                    <span className="text-danger">{errors.phone.message}</span>
                  )}
                </FormGroup>
              </Col>
              <Col xl="4">
                <FormGroup>
                  <Label for="instagram" className="label">
                    Instagram <span>opcional</span>
                  </Label>
                  <Controller
                    name="instagram"
                    control={control}
                    render={({ field }) => <Input {...field} type="text" />}
                  />
                </FormGroup>
              </Col>
            </Row>
          </div>

          <div className={"pt-4"}>
            <h4>Endereço</h4>
            <Row>
              <Col xl="4">
                <FormGroup>
                  <Label for="zipCode" className="">
                    CEP
                  </Label>
                  <Controller
                    name="zipCode"
                    control={control}
                    render={({ field }) => (
                      <ReactInputMask
                        {...field}
                        className="form-control"
                        mask="99999-999"
                        placeholder="Digite seu CEP"
                        maskChar={null}
                        onBlur={handleCepBlur}
                      >
                        {(inputProps) => <input {...inputProps} />}
                      </ReactInputMask>
                    )}
                  />
                  {errors.zipCode && (
                    <span className="text-danger">
                      {errors.zipCode.message}
                    </span>
                  )}
                </FormGroup>
              </Col>
              <Col xl="8">
                <FormGroup>
                  <Label for="address" className="">
                    Endereço
                  </Label>
                  <Controller
                    name="address"
                    control={control}
                    render={({ field }) => <Input {...field} type="text" />}
                  />
                  {errors.address && (
                    <span className="text-danger">
                      {errors.address.message}
                    </span>
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xl="4">
                <FormGroup>
                  <Label for="neighborhood" className="">
                    Bairro
                  </Label>
                  <Controller
                    name="neighborhood"
                    control={control}
                    render={({ field }) => <Input {...field} type="text" />}
                  />
                  {errors.neighborhood && (
                    <span className="text-danger">
                      {errors.neighborhood.message}
                    </span>
                  )}
                </FormGroup>
              </Col>
              <Col xl="4">
                <FormGroup>
                  <Label for="number" className="">
                    Número
                  </Label>
                  <Controller
                    name="number"
                    control={control}
                    render={({ field }) => <Input {...field} type="text" />}
                  />
                  {errors.number && (
                    <span className="text-danger">{errors.number.message}</span>
                  )}
                </FormGroup>
              </Col>
              <Col xl="4">
                <FormGroup>
                  <Label for="complement" className="">
                    Complemento
                  </Label>
                  <Controller
                    name="complement"
                    control={control}
                    render={({ field }) => <Input {...field} type="text" />}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xl="6">
                <FormGroup>
                  <Label for="city" className="">
                    Cidade
                  </Label>
                  <Controller
                    name="city"
                    control={control}
                    render={({ field }) => (
                      <Input {...field} type="text" disabled />
                    )}
                  />
                  {errors.city && (
                    <span className="text-danger">{errors.city.message}</span>
                  )}
                </FormGroup>
              </Col>
              <Col xl="6">
                <FormGroup>
                  <Label for="state" className="">
                    Estado
                  </Label>
                  <Controller
                    name="state"
                    control={control}
                    render={({ field }) => (
                      <Input {...field} type="text" disabled />
                    )}
                  />
                  {errors.state && (
                    <span className="text-danger">{errors.state.message}</span>
                  )}
                </FormGroup>
              </Col>
            </Row>
          </div>

          <Row>
            <Col className="text-center mt-3 px-0">
              <button type="submit" className="btn ms-2 update-data-btn">
                ATUALIZAR DADOS
              </button>
            </Col>
          </Row>
        </form>
      </MyAccountWrapper>
    </div>
  );
}

export default MyData;
